import React from 'react';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { Form, Col, Card } from 'react-bootstrap';

//Components
import { 
    campotexto,      
    camporadio, 
    Campocalendario,
    Campoupload } from '../campos/campos';

//helpers
import Bodychildren from '../../../utils/Bodychildren';

class SessoesForm extends React.Component {

    handleTipoCampo = (tipo) => {
        let campo = {};
        switch (tipo) {
            case 'texto':
                campo = campotexto;
                break;
        
            case 'checkbox':
                campo = camporadio;
                break;

            case 'calendario':
                campo = Campocalendario;
                break;

            case 'upload':
                campo = Campoupload;
                break;

            default:
                campo = campotexto;
                break;
        }

        return campo;
    }
    
    render(){
        return (            
            <Card className='mb-3'>
                <Card.Header><Card.Title>{this.props.formsessao}</Card.Title></Card.Header>
                <Card.Body>
                    {this.props.rows.map((rows, index) => {                               
                        return (
                        <Form.Row key={index}>
                            {rows.map((campo, index) => {
                                if(!campo.name){
                                    return null;
                                }                                
                                return (
                                    <Bodychildren key={index}>
                                        <Form.Group as={Col} md={campo.md} controlId={campo.name}>
                                            <Field 
                                            type={campo.type}                                   
                                            label={campo.label} 
                                            name={campo.name} 
                                            component={this.handleTipoCampo(campo.component)}
                                            value={campo.value} 
                                            form={this.props.form}
                                            preimagens={campo.preimagens?campo.preimagens:[]}
                                            />
                                        </Form.Group>
                                        {campo.onchange&&this.props[campo.onchange]?
                                            <OnChange name={campo.name}>
                                                {this.props[campo.onchange]}
                                            </OnChange>
                                            :
                                            null
                                        }
                                    </Bodychildren>
                                )
                            })}
                        </Form.Row>
                        )
                    })}
                </Card.Body>
            </Card>                    
        );
    }
}

export default SessoesForm;